import React from 'react'

import { ApplicationGateForm } from './ApplicationGateForm'

export const ApplicationGatePage: React.FC = () => <ApplicationGateForm />
